module.exports = __webpack_public_path__ + "img/customlist-icon.21d6eb10.svg";